<template>
    <div class="container-01">
        <h2>EDUCATION</h2>
        <ul class="container-02">
            <li v-for="item in education" :key="item.hash" class="container-03">
                <p class="body">{{ item.title }}</p>
                <p class="summary">{{ item.location }}</p>
                <p class="numeric">{{ item.period }}</p>
            </li>
        </ul>
    </div>
</template>

<script lang="ts">
import { ResumeContact, ResumeEducation } from '@/models/Resume'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    name: "education",
    props: {
        education: {
            type: Array as PropType<ResumeEducation[]>,
            required: true
        } 
    }
})
</script>

<style lang="stylus" scoped>

@import "~../../src/styles/styles";

li 
   text-indent: 0
   list-style-type: none
//    display: flex
//    gap 10px

// ul
    // margin: 0
    // padding: 0
    // display flex
    // flex-direction column
    // gap 20px
</style>